import React, { Component } from 'react';
import get from 'lodash/get';
import Input from '../../../components/UI/CustomInputField';
import WidgetPropTypes from '../types';
import WidgetPagePropTypes from '../../WidgetPage/types';

export const WIDGET_NAME = 'set_user_last_name';

class LastName extends Component {
  constructor() {
    super();

    this.state = { lastName: '' };
  }

  componentDidMount() {
    if (get(this.props, 'app.prefilledAnswers.setLegalLastName')) {
      this.setState({
        lastName: this.props.app.prefilledAnswers.setLegalLastName
      });
    }
  }

  render() {
    const { changeAnswerValue, shouldEnable, widget } = this.props;
    return (
      <div>
        <Input
          id="lastNameId"
          placeholder="Your legal last name"
          type="text"
          value={this.state.lastName}
          onChange={value => {
            this.setState({ lastName: value });
            shouldEnable(widget, value.length > 1);
            changeAnswerValue(widget, value);
          }}
          onClick={this.props.onClick}
          data-e2e="last-name"
        />
      </div>
    );
  }
}

LastName.propTypes = {
  changeAnswerValue: WidgetPropTypes.changeAnswerValue.isRequired,
  index: WidgetPropTypes.index.isRequired,
  onClick: WidgetPropTypes.onClick.isRequired,
  shouldEnable: WidgetPropTypes.shouldEnable.isRequired,
  widget: WidgetPropTypes.widget.isRequired,
  answer: WidgetPagePropTypes.answer
};

export default LastName;
